package one.healthium.paywall.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import co.touchlab.kermit.Logger
import loco.PAYWALL_PRIVACY_BUTTON
import loco.PAYWALL_RESTORE_BUTTON
import loco.PAYWALL_SIGN_IN_BUTTON
import loco.PAYWALL_TERMS_BUTTON
import one.healthium.base.browser.Browser
import one.healthium.base.launcher.LocalPlatformLauncher
import one.healthium.domain.common.TextStyle
import one.healthium.domain.paywall.models.PaywallPrivacyView
import one.healthium.ui.common.utils.toTextStyle
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_4
import one.healthium.ui.compose.theme.gray_7
import one.healthium.url_provider.domain.UrlProviderRepository
import one.healthium.url_provider.domain.UrlType
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject

@Composable
fun PaywallPrivacyView(
    model: PaywallPrivacyView,
    onRestoreClicked: () -> Unit,
    onSignInClicked: () -> Unit,
) {
    val browser = koinInject<Browser>()
    val urlProviderRepository = koinInject<UrlProviderRepository>()
    val platformLauncher = LocalPlatformLauncher.current

    var termsUrl by remember { mutableStateOf("") }
    var privacyUrl by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        try {
            termsUrl = urlProviderRepository.get(UrlType.Terms) ?: ""
        } catch (e: Exception) {
            Logger.e("Failed to fetch terms url", e)
        }
        try {
            privacyUrl = urlProviderRepository.get(UrlType.Privacy) ?: ""
        } catch (e: Exception) {
            Logger.e("Failed to fetch privacy url", e)
        }
    }

    Column {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Button(
                text = stringResource(loco.Res.string.PAYWALL_RESTORE_BUTTON),
                style = model.config.textLabel,
                onClick = onRestoreClicked,
            )
            Divider()
            Button(
                text = stringResource(loco.Res.string.PAYWALL_SIGN_IN_BUTTON),
                style = model.config.textLabel,
                onClick = onSignInClicked,
            )
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Button(
                text = stringResource(loco.Res.string.PAYWALL_TERMS_BUTTON),
                style = model.config.textLabel,
                onClick = {
                    browser.openUrl(platformLauncher, termsUrl)
                },
            )
            Divider()
            Button(
                text = stringResource(loco.Res.string.PAYWALL_PRIVACY_BUTTON),
                style = model.config.textLabel,
                onClick = {
                    browser.openUrl(platformLauncher, privacyUrl)
                },
            )
        }
    }
}

@Composable
private fun Button(
    text: String,
    style: TextStyle?,
    onClick: () -> Unit,
) {
    Text(
        modifier = Modifier
            .clickable { onClick() }
            .clip(RoundedCornerShape(50))
            .padding(8.dp),
        text = text,
        style = style.toTextStyle(AppTheme.textStyles.caption.copy(color = gray_4)),
    )
}

@Composable
private fun Divider() {
    Box(
        Modifier
            .size(width = 2.dp, height = 16.dp)
            .background(gray_7)
    )
}